import React, { useEffect } from "react";
import styles from "../../components/products_list/products_list.module.css";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getCookie } from "../../utils/cookie";
import Loader from "../../components/loader/loader";
import { getLoading, getCategories, getFavorites } from "../../services/selectors";
import { getDataFromRoutes, setMetaTags, getArrayCategoriesWithProducts } from "../../utils/util_functions";
import { ROUTES_CONST } from "../../utils/constants";
import MenuContainer from "../../components/categories_menu/menu_container/menu_container";
import ProductCard from "../../components/product_card/product_card";

const Favorite = () => {

  const dispatch = useDispatch();
  const isLoading = useSelector(getLoading);
  const location = useLocation();
  const { categories } = useSelector(getCategories);

  const { favorites: favoriteProducts, count } = useSelector(getFavorites);

  let accessToken = getCookie('accessToken') || '';
  let refreshToken = getCookie('refreshToken') || '';

  const {
    title, metaTitle, metaDescription, metaKeywords, metaRobots
  } = getDataFromRoutes(location.pathname, ROUTES_CONST);

  useEffect(() => {
    setMetaTags(metaTitle, metaDescription, metaKeywords, metaRobots);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {window.scrollTo({ top: 0, left: 0 })}, []);


  return (
    <main className='main main__sw main__colons' >
      {isLoading && <Loader />}
      <MenuContainer />
      <div className="main_content">
        <h1 className="title">{title}</h1>
        {count === 0 ? <p className="subtitle gray">Избранных товаров пока нет</p> :
          <ul className={styles.categoriesList}>
            {getArrayCategoriesWithProducts(favoriteProducts, categories).map(item => {
              return (
                <li key={item.categorySlug} className={styles.item}>
                  <p className={`${styles.category_noHover}`}>
                    {item.categoryName} ({item.products.length})
                  </p>
                  <ul className={styles.listSale}>
                    {item.products.map(product =>
                      <li key={product.id}>
                        <Link to={product.path}
                          className={styles.productCard}
                        >
                          <ProductCard product={product} />
                        </Link>
                      </li>
                    )}
                  </ul>
                </li>
              )
            })}
          </ul>}
      </div>
    </main>
  );
};

export default Favorite;
